import { getPointerType, type DevicePointerType } from "@otto-ec/global-resources/device";

const deviceProps = $state<DevicePointerType>({
  isTouchable: false,
  isHybrid: false,
  isMouse: true,
});

/**
 *
 */
export type DeviceProperties = DevicePointerType;

/**
 *
 *
 *
 */
export function useDeviceProperties(): DevicePointerType {
  const pointer = getPointerType();
  deviceProps.isTouchable = pointer.isTouchable;
  deviceProps.isHybrid = pointer.isHybrid;
  return deviceProps;
}
